module.exports = __webpack_public_path__ + "img/image15.9231a624.webp";